import { Link } from 'react-router-dom'
import { Pin } from 'lucide-react'
import { PageHeader, PageShell } from '@/components/portal/page-header'
import { Badge } from '@/components/ui/badge'
import { useAnnouncements } from '@/hooks/use-announcements'
import { formatDate } from '@/lib/utils'
import { htmlToExcerpt } from '@riverpark/utils/html'
import type { AnnouncementCategory } from '@riverpark/types'

const CATEGORY_BADGE: Record<
  AnnouncementCategory,
  { variant: 'overdue' | 'pending' | 'credit' | 'committee' | 'default'; label: string }
> = {
  urgent: { variant: 'overdue', label: 'Urgent' },
  maintenance: { variant: 'pending', label: 'Maintenance' },
  financial: { variant: 'credit', label: 'Financial' },
  governance: { variant: 'committee', label: 'Governance' },
  general: { variant: 'default', label: 'General' },
}

export function MemberAnnouncements() {
  const { data, isLoading } = useAnnouncements({ limit: 50 })
  const items = data?.data ?? []

  return (
    <PageShell>
      <PageHeader
        label="Estate"
        title="Notices"
        description="Announcements and updates from estate management."
      />

      {isLoading ? (
        <p className="font-sans text-sm text-muted-foreground">Loading…</p>
      ) : items.length === 0 ? (
        <p className="rounded border border-border-2 px-4 py-6 text-center font-sans text-sm text-muted-foreground">
          No notices yet.
        </p>
      ) : (
        <div className="space-y-3">
          {items.map((a) => (
            <div key={a.id} className="rounded-card border border-border-2 bg-card p-4">
              <div className="flex items-center gap-2">
                {a.pinned && <Pin size={14} className="text-primary" />}
                <Link
                  to={`/announcements/${a.id}`}
                  className="font-serif text-lg text-ink hover:text-primary hover:underline"
                >
                  {a.title}
                </Link>
                <Badge variant={CATEGORY_BADGE[a.category].variant}>
                  {CATEGORY_BADGE[a.category].label}
                </Badge>
              </div>
              <p className="mt-2 font-sans text-sm text-ink">{htmlToExcerpt(a.body)}</p>
              <p className="mt-2 font-sans text-xs text-muted-foreground">
                {a.authorName} · {formatDate(new Date(a.createdAt * 1000))}
              </p>
            </div>
          ))}
        </div>
      )}
    </PageShell>
  )
}
